window.MenuAcoesProdutosController = ObjectBase.extend({
    show: function () {
        //this.atacharEventos();
        $("#menu-acoes-produtos").show();
    },

    hide: function () {
        $("#menu-acoes-produtos").hide();
    }

}
);